var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaSuspense1Bloq({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 261,
    viewBox: "0 0 213 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 261,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 112.94C170.182 150.183 142.321 168.805 109.206 179.606C107.472 180.156 105.589 180.129 103.873 179.531C70.6786 168.805 42.8175 150.183 42.8175 112.94V60.7984C42.8175 58.8228 43.6562 56.9282 45.149 55.5313C46.6419 54.1344 48.6666 53.3496 50.7778 53.3496C66.6984 53.3496 86.5992 44.4111 100.45 33.089C102.137 31.7408 104.282 31 106.5 31C108.718 31 110.863 31.7408 112.55 33.089C126.48 44.4856 146.302 53.3496 162.222 53.3496C164.333 53.3496 166.358 54.1344 167.851 55.5313C169.344 56.9282 170.182 58.8228 170.182 60.7984V112.94Z",
    fill: "url(#paint0_linear_2162_31222)",
    stroke: "url(#paint1_linear_2162_31222)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5001 96C99.5001 96 105 90 104.5 90C104 90 93.0001 90 92.5001 90C92.0001 90 97.5001 96 98.5001 96Z",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 127.786H116.75M80.5 76H116.75M111.571 127.786V116.983C111.571 115.61 111.025 114.293 110.054 113.322L98.625 101.893M98.625 101.893L87.1959 113.322C86.2247 114.293 85.6789 115.61 85.6786 116.983V127.786M98.625 101.893L87.1959 90.4638C86.2247 89.4928 85.6789 88.1758 85.6786 86.8025V76M98.625 101.893L110.054 90.4638C111.025 89.4928 111.571 88.1758 111.571 86.8025V76",
    stroke: "#C0C0C0",
    strokeWidth: 5.17857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.333 142.834L123.156 133.656L132.333 142.834Z",
    fill: "#C0C0C0",
    fillOpacity: 0.62
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.333 142.834L123.156 133.656",
    stroke: "#C0C0C0",
    strokeWidth: 4.22917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.245 136.49C119.836 136.49 125.99 130.336 125.99 122.745C125.99 115.154 119.836 109 112.245 109C104.654 109 98.5 115.154 98.5 122.745C98.5 130.336 104.654 136.49 112.245 136.49Z",
    fill: "#C0C0C0",
    fillOpacity: 0.62,
    stroke: "#C0C0C0",
    strokeWidth: 3.4362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5327 202.636V223H78.7088L68.358 208.065H68.169V223H65.0966V202.636H67.9403L78.3011 217.591H78.4901V202.636H81.5327ZM85.7759 223V207.727H88.7489V223H85.7759ZM86.0543 205.689L88.381 201.105H91.5131L88.4308 205.689H86.0543ZM105.814 207.727L100.276 223H97.0938L91.5455 207.727H94.7372L98.6051 219.48H98.7642L102.622 207.727H105.814ZM114.671 223.308C113.166 223.308 111.87 222.987 110.783 222.344C109.703 221.694 108.867 220.783 108.277 219.609C107.694 218.429 107.402 217.047 107.402 215.463C107.402 213.899 107.694 212.52 108.277 211.327C108.867 210.134 109.689 209.202 110.743 208.533C111.804 207.863 113.043 207.528 114.462 207.528C115.324 207.528 116.159 207.671 116.968 207.956C117.776 208.241 118.502 208.688 119.145 209.298C119.788 209.908 120.295 210.7 120.667 211.675C121.038 212.643 121.223 213.819 121.223 215.205V216.259H109.083V214.031H118.31C118.31 213.249 118.151 212.556 117.833 211.953C117.515 211.343 117.067 210.863 116.49 210.511C115.92 210.16 115.251 209.984 114.482 209.984C113.647 209.984 112.917 210.19 112.294 210.601C111.678 211.005 111.201 211.536 110.863 212.192C110.531 212.841 110.365 213.547 110.365 214.31V216.05C110.365 217.071 110.544 217.939 110.902 218.655C111.267 219.371 111.774 219.918 112.424 220.295C113.073 220.667 113.832 220.852 114.701 220.852C115.264 220.852 115.778 220.773 116.242 220.614C116.706 220.448 117.107 220.203 117.445 219.878C117.783 219.553 118.042 219.152 118.221 218.675L121.034 219.182C120.809 220.01 120.405 220.736 119.821 221.359C119.245 221.976 118.519 222.456 117.644 222.801C116.775 223.139 115.784 223.308 114.671 223.308ZM127.495 202.636V223H124.522V202.636H127.495ZM146.591 202.636V223H143.509V205.719H143.389L138.517 208.901V205.957L143.598 202.636H146.591Z",
    fill: "#C0C0C0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5 127.61V123.5C93.5 119.92 94.9223 116.486 97.4541 113.954C99.9858 111.422 103.42 110 107 110C110.58 110 114.014 111.422 116.546 113.954C119.078 116.486 120.5 119.92 120.5 123.5V127.61C122.73 127.776 124.18 128.196 125.242 129.258C127 131.014 127 133.844 127 139.5C127 145.156 127 147.986 125.242 149.742C123.486 151.5 120.656 151.5 115 151.5H99C93.344 151.5 90.514 151.5 88.758 149.742C87 147.986 87 145.156 87 139.5C87 133.844 87 131.014 88.758 129.258C89.818 128.196 91.27 127.776 93.5 127.61ZM96.5 123.5C96.5 120.715 97.6062 118.045 99.5754 116.075C101.545 114.106 104.215 113 107 113C109.785 113 112.455 114.106 114.425 116.075C116.394 118.045 117.5 120.715 117.5 123.5V127.508C116.735 127.501 115.901 127.499 115 127.5H99C98.0973 127.499 97.264 127.501 96.5 127.508V123.5ZM107 134C107.398 134 107.779 134.158 108.061 134.439C108.342 134.721 108.5 135.102 108.5 135.5V143.5C108.5 143.898 108.342 144.279 108.061 144.561C107.779 144.842 107.398 145 107 145C106.602 145 106.221 144.842 105.939 144.561C105.658 144.279 105.5 143.898 105.5 143.5V135.5C105.5 135.102 105.658 134.721 105.939 134.439C106.221 134.158 106.602 134 107 134Z",
    fill: "#8E58BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_31222",
    x1: 106.5,
    y1: 31,
    x2: 106.5,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_31222",
    x1: 106.5,
    y1: 31,
    x2: 106.5,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaSuspense1Bloq);
export default __webpack_public_path__ + "static/media/Medalha_suspense_1_bloq.8dafe46ab3dc4bdb6ac8ef34d8840e54.svg";
export { ForwardRef as ReactComponent };